module.exports = __webpack_public_path__ + "static/media/robert-beard-at-sanding-machine.c5e2a14c.webp";